import React from 'react'
import { Link } from 'react-router-dom'
import { FaRegEdit, FaTrashAlt } from "react-icons/fa";
import { Button } from 'react-bootstrap';
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

export default class ListSystemEmailComponent extends React.Component {

    checkedEmail = (e) => {
        if ( e.nativeEvent.shiftKey ) {
            let value = e.target.checked;
            this.props.checkedEmailShiftKey( this.props.actionKey, value );
        } else {
            this.props.checkedEmail( this.props.actionKey );
        }
    }

	render() {
		return (
			<tr>
				<td className="text-center email-selected">
                    <input 
                    	type="checkbox" 
                    	checked={this.props.email.checked}  
                    	onChange={ this.checkedEmail } 
                    />
                </td>
				<td>

                    <Link
                        to={'/admin/system-email/edit/' + this.props.email.id }

                    >
                        { this.props.email.title }
                    </Link>
                </td>
				<td>{ this.props.email.subject }</td>
				<td>{ this.props.email.service }</td>
				<td>
					<OverlayTrigger
                        overlay={(props) => (
                            <Tooltip {...props}>
                                Chi tiết
                            </Tooltip>
                        )}
                        placement="top"
                    >
						<Link 
							className="btn btn-warning btn-sm m-1"
							to={'/admin/system-email/edit/' + this.props.email.id }

						>
							<FaRegEdit />
						</Link>
					</OverlayTrigger>

					<OverlayTrigger
                        overlay={(props) => (
                            <Tooltip {...props}>
                                Xóa
                            </Tooltip>
                        )}
                        placement="top"
                    >
						<Button 
	    					className="btn btn-danger btn-sm m-1"
							onClick={ () => this.props.delete(this.props.email.id) }
						>
							<FaTrashAlt />
					  	</Button>
				  	</OverlayTrigger>
				</td>
			</tr>
		)
	}
}